import { useSelector } from "react-redux";
import { useGetProtectedApiDataQuery } from "../../redux/services/apiSlice";
import { useLanguageTranslation } from "../../hooks/useLanguageTranslation";
import Loader from "../Loader";
import HighchartsReact from "highcharts-react-official";
import Highcharts from "highcharts";
import Highcharts3D from "highcharts/highcharts-3d";

const PowerShareChart = () => {
  const { languageType } = useSelector((state) => state.homeSlice);
  const { data: powerShareInNE = [], isLoading: announcementsIsLoading } =
    useGetProtectedApiDataQuery({
      url: "power_share_of_neepco_in_north_east_india",
      lang: languageType,
    });

  const { getText } = useLanguageTranslation();

  const options = {
    chart: {
      type: "pie",
      options3d: {
        enabled: true,
        alpha: 45,
        beta: 0,
      },
    },
    title: {
      text: getText(
        "Power Share of NEEPCO in N.E.",
        "नीपको का पूर्वोत्तर में पावर शेयर"
      ),
      align: "left", // 🔑 align left instead of center
      y: 30,
      x: 10, // extra padding from left
      margin: 40,
    },
    accessibility: {
      point: {
        valueSuffix: "%",
      },
    },
    tooltip: {
      pointFormat: "{series.name}: <b>{point.percentage:.1f}%</b>",
    },
    plotOptions: {
      pie: {
        allowPointSelect: true,
        cursor: "pointer",
        depth: 45,
        dataLabels: {
          enabled: false,
        },
        showInLegend: true,
      },
    },
    legend: {
      align: "right", // ✅ position legend on left
      verticalAlign: "middle",
      layout: "vertical",
      itemMarginTop: 8,
      margin: -5,
      x: 0,
      y: 35,
      itemStyle: {
        color: "#000", // 🔥 legend text color
        fontWeight: "normal",
        fontSize: "12px",
        // fontWeight: 600,
      },
    },
    series: [
      {
        type: "pie",
        name: "Share",
        data: powerShareInNE.map((item) => [
          item.field_states, // label like "NEEPCO (2057 MW)"
          parseFloat(item.field_capacity_in_mw), // number like 2057
        ]),
      },
    ],
  };

  // if (announcementsIsLoading) {
  //   return <Loader />;
  // }

  return (
    <>
      <div className="performance-generation-sec h-100 wow zoomIn">
        <div className="cursor-none">
          <HighchartsReact highcharts={Highcharts} options={options} />
        </div>

        <div className="sr-only" aria-hidden="false">
          <h4>{getText("Chart Legend", "चार्ट की जानकारी")}</h4>
          <ul>
            {powerShareInNE.map((item) => (
              <li key={item.field_states}>
                {item.field_states}: {parseInt(item.field_capacity_in_mw)} MW
              </li>
            ))}
          </ul>
        </div>
      </div>
    </>
  );
};

export default PowerShareChart;
